function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28.8644 7.52469V13.5897H32.6047C33.496 13.5897 34.2328 13.2896 34.8151 12.691C35.4137 12.0939 35.7137 11.3809 35.7137 10.5564C35.7137 9.74837 35.4137 9.04428 34.8151 8.44417C34.2328 7.83069 33.496 7.52321 32.6047 7.52321H28.8644V7.52469ZM28.8644 15.7242V22.7592H26.6304V5.39014H32.5572C34.0619 5.39014 35.3394 5.89072 36.3926 6.89339C37.4621 7.89605 37.9968 9.11707 37.9968 10.5564C37.9968 12.0285 37.4621 13.2584 36.3926 14.2433C35.3572 15.2311 34.0768 15.7227 32.5557 15.7227H28.8644V15.7242ZM40.2547 19.1214C40.2547 19.7037 40.5013 20.1879 40.9959 20.5771C41.4891 20.9633 42.0684 21.1579 42.7309 21.1579C43.6712 21.1579 44.5075 20.8103 45.2442 20.1166C45.9825 19.42 46.3494 18.603 46.3494 17.6657C45.6527 17.1161 44.6812 16.8413 43.435 16.8413C42.5289 16.8413 41.7713 17.0611 41.1652 17.4978C40.5577 17.9345 40.2547 18.4738 40.2547 19.1214ZM43.1453 10.4837C44.7971 10.4837 46.0998 10.9248 47.0564 11.8057C48.0101 12.688 48.4884 13.8972 48.4884 15.4331V22.7592H46.3509V21.1104H46.2543C45.3304 22.4681 44.1004 23.1484 42.5615 23.1484C41.2514 23.1484 40.1537 22.7592 39.2713 21.9838C38.389 21.2069 37.9478 20.237 37.9478 19.0724C37.9478 17.8424 38.4128 16.865 39.3441 16.1372C40.2755 15.4093 41.5173 15.0454 43.0725 15.0454C44.3975 15.0454 45.4923 15.2875 46.3494 15.7733V15.2623C46.3494 14.4869 46.0419 13.8273 45.4269 13.2867C44.8344 12.7535 44.0627 12.4633 43.2656 12.4741C42.0179 12.4741 41.0316 12.9985 40.3022 14.0516L38.3355 12.8128C39.4199 11.2605 41.0241 10.4837 43.1453 10.4837ZM60.7521 10.8728L53.2952 27.9998H50.9884L53.7572 22.0076L48.8523 10.8728H51.281L54.8267 19.4125H54.8742L58.3234 10.8714L60.7521 10.8728Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.8361 14.2078C19.8361 13.5052 19.7767 12.8264 19.6638 12.1787H10.2402V16.023H15.6383C15.5276 16.6372 15.2937 17.2227 14.9506 17.744C14.6075 18.2653 14.1623 18.7117 13.6419 19.0562V21.5517H16.8637C18.7502 19.8138 19.8361 17.244 19.8361 14.2078Z",
  fill: "#4285F4"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.2403 23.9609C12.9378 23.9609 15.2075 23.0771 16.8638 21.5531L13.6419 19.0561C12.7462 19.6591 11.592 20.0112 10.2403 20.0112C7.63483 20.0112 5.42155 18.2554 4.6313 15.8906H1.31287V18.4619C2.14534 20.1157 3.42088 21.5058 4.99722 22.477C6.57357 23.4483 8.38873 23.9625 10.2403 23.9624",
  fill: "#34A853"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.63129 15.8908C4.21444 14.6514 4.21444 13.3097 4.63129 12.0703V9.49902H1.31286C0.611335 10.8882 0.246489 12.4228 0.247806 13.9791C0.247806 15.5907 0.634017 17.1133 1.31286 18.4606L4.63129 15.8893V15.8908Z",
  fill: "#FABB05"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.2402 7.94974C11.7138 7.94974 13.0328 8.45479 14.0726 9.44705V9.44854L16.9247 6.59949C15.1956 4.98929 12.9378 4 10.2417 4C8.39035 3.99975 6.5753 4.51378 4.99897 5.48475C3.42264 6.45573 2.14701 7.84549 1.31433 9.49904L4.63277 12.0703C5.42301 9.70551 7.6363 7.94974 10.2417 7.94974",
  fill: "#E94235"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 60.5043,
  height: 32,
  fill: "white",
  transform: "translate(0.247803)"
})));

function SvgGooglePay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 32,
    viewBox: "0 0 61 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePay);
export default __webpack_public_path__ + "static/media/google-pay.9cb682d0.svg";
export { ForwardRef as ReactComponent };